// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_ejWkh {
  max-width: 100%;
  height: 250px;
  width: 444px;
  border-radius: 4px;
  background-color: var(--color-base025);
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/aisleHeatmapping/components/AisleImage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".image {\n  max-width: 100%;\n  height: 250px;\n  width: 444px;\n  border-radius: 4px;\n  background-color: var(--color-base025);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `image_ejWkh`
};
export default ___CSS_LOADER_EXPORT___;
